export { default as getValidProps } from './getValidProps';
